import React from "react";
import { Card, Text, createStyles, Flex } from "@mantine/core";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const useStyles = createStyles((theme) => ({
  card: {
    padding: theme.spacing.md,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.sm,
    backgroundColor: theme.white,
    marginBottom: theme.spacing.md,
    marginLeft: "10px",
    width: "98%",
  },
  title: {
    fontSize: theme.fontSizes.lg,
    fontWeight: 600,
    marginBottom: theme.spacing.md,
    color: theme.colors.dark[7],
  },
}));

const OrdersBarChart = ({ data }) => {
  const { classes } = useStyles();

  const chartData = {
    labels: data?.map((item) => item.business_name) || [],
    datasets: [
      {
        label: "Total Orders",
        data: data?.map((item) => item.total_orders) || [],
        backgroundColor: "#1B91DF",
        borderColor: "#1B91DF",
        borderWidth: 1,
        barPercentage: 0.5,
        datalabels: {
          display: true,
          anchor: "end",
          align: "end",
          color: "#000",
          font: { weight: "bold", size: 12 },
          formatter: (value, context) => {
            const business = data[context.dataIndex];
            return business
              ? `Sales: ${business.total_sales.toLocaleString()}`
              : "0";
          },
          offset: 0,
          clamp: true,
          padding: 4,
        },
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 10,
        bottom: 10,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Business Name",
          font: { size: 14 },
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Total Orders",
          font: { size: 14 },
        },
        ticks: {
          stepSize: 1,
          callback: (value) => value.toLocaleString(),
        },
        max: Math.ceil(
          Math.max(...(data?.map((item) => item.total_orders) || [0])) * 1.3
        ),
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        align: "end",
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const business = data[context.dataIndex];
            return business
              ? `Total Sales: ${business.total_sales.toLocaleString()}`
              : "No data";
          },
        },
      },
      datalabels: {
        display: true,
      },
    },
  };

  return (
    <Card className={classes.card}>
      <Text className={classes.title}>Orders Bar Chart</Text>
      <Flex direction="column" style={{ height: "350px", overflowX: "auto" }}>
        <Bar data={chartData} options={options} />
      </Flex>
    </Card>
  );
};

export default OrdersBarChart;
